<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på storlek</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';

export default {
    name: 'FontSizeFilter',
    components: {
        VueSelect,
    },
    data() {
        return {
            options: [
                { label: '12px', id: 12 },
                { label: '14px', id: 14 },
                { label: '16px', id: 16 },
                { label: '18px', id: 18 },
                { label: '22px', id: 22 },
                { label: '24px', id: 24 },
                { label: '26px', id: 26 },
                { label: '28px', id: 28 },
                { label: '32px', id: 32 },
                { label: '36px', id: 36 },
                { label: '40px', id: 40 },
                { label: '44px', id: 44 },
                { label: '48px', id: 48 },
                { label: '52px', id: 52 },
            ],
        };
    },
};
</script>
